import { doGetOld, doPostOld, doDeleteOld } from '@/services/api/myBase'

export const getPaymentCards = async (page: ApiPage): Promise<ApiListResponseOld> => {
  const path = page ? `/api/customers/payment_cards?page=${page}` : '/api/customers/payment_cards'
  return await doGetOld(path)
}

export const requestSetupIntent = async (): Promise<SetupIntentResponse> => {
  return await doPostOld('/api/customers/payment_cards/setup_intent')
}

export const createPaymentCard = async (
  data: CreatePaymentCard
): Promise<CreatePaymentCardResponse> => {
  return await doPostOld('/api/customers/payment_cards', data)
}

export const setCardAsPrimary = async (cardId: string): Promise<ApiNoContentResponse> => {
  return await doPostOld(`/api/customers/payment_cards/${cardId}/primary`)
}

export const deletePaymentCard = async (cardId: string): Promise<ApiNoContentResponse> => {
  return await doDeleteOld(`/api/customers/payment_cards/${cardId}`)
}

export default {
  getPaymentCards,
  requestSetupIntent,
  createPaymentCard,
  setCardAsPrimary,
  deletePaymentCard
}
